import { render, staticRenderFns } from "./SequencingAnalysis.vue?vue&type=template&id=2b40aff0&scoped=true&"
import script from "./SequencingAnalysis.vue?vue&type=script&lang=js&"
export * from "./SequencingAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./SequencingAnalysis.vue?vue&type=style&index=0&id=2b40aff0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/ronaspergel/Projects/otjs/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b40aff0",
  null
  
)

export default component.exports